module.exports = __webpack_public_path__ + "static/media/error.2a1f2ddd.png";